import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationReportUIContext } from "./OrganizationReportUIContext";
import { OrganizationReportFilter } from "./organization-report-table/organization-report-filter/OrganizationReportFilter";
import OrganizationReportDetail from "./organization-report-detail/OrganizationReportDetail";
import {
  fetchOrganizationReports,
  createOrganizationReport,
  updateOrganizationReport
} from "../../_redux/organization-report/organizationReportAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import OrganizationReportTable from "./organization-report-table/OrganizationReportTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { generateMemoPPD } from "../../_redux/consolidation-report/consolidationReportCrud";
import GenerateMemoModal from "./generate-memo-modal/GenerateMemoModal";
import { RoleChecker } from "../../../../RoleChecker";

export const OrganizationReportCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(false);

  // * OrganizationReport UI Context
  const organizationReportUIContext = useOrganizationReportUIContext();
  const organizationReportUIProps = useMemo(() => {
    return {
      queryParams: organizationReportUIContext.queryParams,
      setQueryParams: organizationReportUIContext.setQueryParams,
      openDetailOrganizationReportPage:
        organizationReportUIContext.openDetailOrganizationReportPage
    };
  }, [organizationReportUIContext]);

  // * Getting curret state of organizationReport list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminOrganizationReport,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke OrganizationReport Action
    dispatch(fetchOrganizationReports(organizationReportUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationReportUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "organization_report");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Laporan Organisasi">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div id="collapse-filter-report">
              <OrganizationReportFilter />
            </div>
          </Collapse>
          <OrganizationReportTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={organizationReportUIProps.queryParams}
            setQueryParams={organizationReportUIProps.setQueryParams}
            openDetailOrganizationReportPage={
              organizationReportUIProps.openDetailOrganizationReportPage
            }
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
